module.exports = __webpack_public_path__ + "static/asset-allocation-graphic.0c0b1ef1.webp";